import React, { PureComponent } from 'react';
import styled from 'styled-components';

import Button from 'shared/components/presentational/Button';
import Select from 'shared/components/presentational/Select';
import TextAutoComplete from 'shared/components/presentational/TextAutoComplete';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import { FILTERS_TYPE } from '../../../shared/constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  margin: 0 auto;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
  max-width: 1000px;

  ${mediaQueries.toTablet`
    padding-left: 10px;
    padding-right: 10px;
    max-width: 520px;
    flex-wrap: wrap-reverse;
  `}

  ${mediaQueries.toPhablet`
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    padding-left: 20px;
    padding-right: 20px;
  `};
`;

const StyledButton = styled(Button)`
  margin: 6px;
  flex-basis: 224px;
  flex-shrink: 0;

  ${mediaQueries.toTablet`
    margin: 5px;
    flex-basis: 240px;
  `};

  ${mediaQueries.toPhablet`
    flex-basis: 40px;
  `};
`;

const StyledSelect = styled(Select)`
  margin: 6px;
  width: 240px;

  ${mediaQueries.toTablet`
    margin: 5px;
  `};

  ${mediaQueries.toPhablet`
    flex-basis: 40px;
  `};
`;

const StyledTextAutoComplete = styled(TextAutoComplete)`
  margin: 5px;
  flex-basis: 40px;
  display: inline-block;
  min-width: 200px;

  ${mediaQueries.fromDesktop`
    margin: 6px;
  `};

  ${mediaQueries.fromTablet`
      flex-basis: 240px;
  `};
`;

export default class Filters extends PureComponent {
  handleFilterChange = filterOn => data => {
    const value = data ? data.value : null;
    this.props.onFilterChange(filterOn, value);
  };

  handleLocate = () => {
    this.props.fetchCoordinates();
  };

  render() {
    const { handleLocate, handleFilterChange } = this;
    const {
      className,
      buttonGeolocation,
      filters,
      fetchingCoordinatesPending: locatePending,
      t
    } = this.props;

    return (
      <Wrapper className={className}>
        {filters
          .reverse()
          .map(filter =>
            filter.type === FILTERS_TYPE.SELECT ? (
              <StyledSelect
                key={`Filters_${filter.id}`}
                onChange={handleFilterChange(filter.filterOn)}
                options={filter.options}
                placeholder={filter.name}
                value={filter.options.filter(
                  option => option.value === filter.value
                )}
                isClearable={true}
              />
            ) : (
              <StyledTextAutoComplete
                key={`Filters_${filter.id}`}
                onChange={handleFilterChange(filter.filterOn)}
                items={filter.options}
                placeholder={t(filter.name)}
              />
            )
          )}
        <StyledButton
          variant="primary"
          onClick={handleLocate}
          loading={locatePending}
        >
          <Button.children.SvgIcon
            width="16"
            height="16"
            xlink="/sprite.svg#cos-svg-pin"
          />
          <Button.children.Text>{buttonGeolocation}</Button.children.Text>
        </StyledButton>
      </Wrapper>
    );
  }
}
